import React from "react";
import styles from "./RegisterPage.module.css";
//import planImage from "../assets/plan-placeholder.png"; // Image illustrative
import RegisterForm from "./RegisterForm";
import i18n from "../Services/i18n";

const RegisterPage = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.heroSection}>
        <div className={styles.equestrologLogo}>Rejoignez Equestrolog</div>
        <h2 className={styles.loginSlogan}>{i18n.t("LoginForm.Moto")} </h2>
      </div>

      <RegisterForm />
    </div>
  );
};

export default RegisterPage;
